export const defualtMeta = [
  {
    vmid: "description",
    name: "description",
    content: "위생교육, 수입식품교육,수입식품위생교육,GMP교육,건강기능식품교육,일반판매업,한국건강기능식품협회교육, 건강기능식품 수입식품 온라인 위생교육기관",
  },
  {
    vmid: "keywords",
    name: "keywords",
    content: "위생교육, 수입식품교육, 수입식품위생교육,  GMP교육, 건강기능식품법, 건강기능식품, 건강기능식품 판매, 법정교육, 수입식품안전관리 특별법, 건강기능식품협회, 수입식품협회, 전문제조업, 벤처제조업, 품질관리인, 한국건강기능식품협회, 건강기능식품 수입식품 온라인 위생교육기관",
  },
  {
    hid: 'og:title',
    property: 'og:title',
    content: '건강기능식품&수입식품 온라인 위생교육기관'
  },
  {
    hid: 'og:description',
    property: 'og:description',
    content: '위생교육, 수입식품교육,수입식품위생교육,GMP교육,건강기능식품교육,일반판매업,한국건강기능식품협회교육, 건강기능식품 수입식품 온라인 위생교육기관'
  },
  {
    hid: 'og:image',
    property: 'og:image',
    content: 'https://edu.khff.or.kr/assets/images/user2022/logo/og-image.png'
  },
  { name: "viewport", content: "width=device-width, initial-scale=1" },
  { rel: "favicon", href: "favicon.ico" },
];
